import { createRef } from "react";

export const handleSubmitRef = createRef();
